import { createContext, useContext, type ReactNode } from 'react';

interface SessionContextValue {
  sessionId: string | null;
  sessionExpiresAt: string | null;
}

const SessionContext = createContext<SessionContextValue | null>(null);

interface SessionProviderProps {
  children: ReactNode;
  sessionId?: string | null;
  sessionExpiresAt?: string | null;
}

export function SessionProvider({
  children,
  sessionId = null,
  sessionExpiresAt = null,
}: SessionProviderProps) {
  const value: SessionContextValue = {
    sessionId,
    sessionExpiresAt,
  };

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
}
